import { Dialog } from "primereact/dialog";
import TextField from "../../components/Textfield/TextField";
// import { editUser as editUserAPI } from "../../services/services";
import { useQueryClient } from "@tanstack/react-query";

const ModalEditUser = ({
  editUser,
  editUserModal,
  setEditUserModal,
  setEditUser,
}) => {
  const queryClient = useQueryClient();

  return (
    <Dialog
      header={` ویرایش کاربر: ${editUser?.fullName}   `}
      visible={editUserModal}
      style={{ width: "30vw", height: "14vw" }}
      maximizable
      modal
      contentStyle={{ height: "300px", overflowX: "hidden" }}
      onHide={() => setEditUserModal(false)}
      className="farsi-monospace-digit custom-dialog"
    >
      <div className="row justify-content-center">
        <div className="col-12 col-xl-5 mt-3">
          <TextField
            value={editUser?.firstName || ""}
            label={"اسم"}
            onChange={(e) => {
              setEditUser({ ...editUser, firstName: e.target.value });
            }}
          />
        </div>
        <div className="col-12 col-xl-5 mt-3">
          <TextField
            value={editUser?.phoneNumber}
            label={"شماره موبایل"}
            onChange={(e) =>
              setEditUser({ ...editUser, phoneNumber: e.target.value })
            }
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-12 col-xl-5 mt-3">
          <TextField
            value={editUser?.balance}
            label={"تعداد سکه"}
            onChange={(e) =>
              setEditUser({ ...editUser, balance: e.target.value })
            }
            type="number"
          />
        </div>
        <div className="col-12 col-xl-5 mt-3">
          <TextField
            value={editUser?.userCityName}
            label={"شهر"}
            onChange={(e) =>
              setEditUser({ ...editUser, userCityName: e.target.value })
            }
          />
        </div>
      </div>
      <div className="row justify-content-center">
        <button
          style={{
            color: "#ffff",
            background: "#13742b",
            border: "0px",
            width: "68px",
            borderRadius: "8px",
            padding: "2px",
            marginTop: "20px",
          }}
          // onClick={() => {
          //   editUserAPI({
          //     Name: editUser.name,
          //     City: editUser.city,
          //     State: editUser.state,
          //     PhoneNumber: editUser.phoneNumber,
          //     Score: editUser.score,
          //   }).then((res) => {
          //     queryClient.invalidateQueries(["getUsers"]);
          //     setEditUserModal(false);
          //   });
          // }}
        >
          ثبت
        </button>
      </div>
    </Dialog>
  );
};
export default ModalEditUser;
